module.exports = __webpack_public_path__ + "static/media/person02.e8d13b3c.mp4";